import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        redirect: "/home",
        name: "app",
        component: () => import("@/layout/index.vue"),
        children: [
            {
                path: "home",
                component: () => import("@/views/Home/index.vue"),
                name: "Home",
                meta: {
                    title: "トップ"
                }
            },
            {
                path: "company-info",
                component: () => import("@/views/CompanyInfo/index.vue"),
                name: "CompanyInfo",
                meta: {
                    title: "企業情報"
                }
            }, 
            {
                path: "services",
                component: () => import("@/views/Services/index.vue"),
                name: "Services",
                meta: {
                    title: "事業内容"
                }
            }, 
            {
                path: "sino-japan-trade",
                component: () => import("@/views/SinoJapanTrade/index.vue"),
                name: "SinoJapanTrade",
                meta: {
                    title: "日中貿易業務"
                }
            }, 
            {
                path: "partner",
                component: () => import("@/views/Partner/index.vue"),
                name: "Partner",
                meta: {
                    title: "パートナー募集"
                }
            }, 
            {
                path: "recruitment",
                component: () => import("@/views/Recruitment/index.vue"),
                name: "Recruitment",
                meta: {
                    title: "人材募集"
                }
            }, 
            {
                path: "inquiry",
                component: () => import("@/views/Inquiry/index.vue"),
                name: "Inquiry",
                meta: {
                    title: "問い合わせ"
                }
            }, 
            {
                path: "support",
                component: () => import("@/views/Support/index.vue"),
                name: "Support",
                meta: {
                    title: "ITヘルプデスク"
                }
            },
            {
                path: "Solution",
                component: () => import("@/views/Solution/index.vue"),
                name: "Solution",
                meta: {
                    title: "ソリューション事業"
                }
            },
            {
                path: "development",
                component: () => import("@/views/Development/index.vue"),
                name: "Development",
                meta: {
                    title: "システム開発"
                }
            },
            {
                path: "Maintenance",
                component: () => import("@/views/Maintenance/index.vue"),
                name: "Maintenance",
                meta: {
                    title: "運用保守"
                }
            },
            {
                path: "Offshore",
                component: () => import("@/views/Offshore/index.vue"),
                name: "Offshore",
                meta: {
                    title: "オフショア開発"
                }
            },

        ]
    }
]

const router = new VueRouter({
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
            // 让 Vue Router 先滚动到目标 ID
            const scrollOptions = {
                selector: to.hash, // Vue Router 处理滚动
                behavior: "smooth"
            };

            // 延迟调整滚动偏移
            setTimeout(() => {
                const element = document.querySelector(to.hash);
                if (element) {
                    const offset = 40; // 向下偏移 40px
                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                }
            }, 100); // 100ms 确保页面已加载

            return scrollOptions;
        }
        return { x: 0, y: 0 }; 
    }
})

export default router
